/**
 * onClick for an in-page `#anchor` link: glides there instead of jumping, unless the reader asked
 * for less motion. The target's `scroll-margin-top` still sets where it lands. An anchor missing
 * from the page falls through to the browser's own jump.
 */
export function scrollToAnchor(e: React.MouseEvent<HTMLAnchorElement>): void {
  const el = document.getElementById(e.currentTarget.hash.slice(1))
  if (!el) {
    return
  }
  e.preventDefault()
  const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches
  el.scrollIntoView({ block: 'start', behavior: reduced ? 'auto' : 'smooth' })
}
